// extracted by mini-css-extract-plugin
export default {"container":"ESIMSelectPlans_container__Z9Gwh","title":"ESIMSelectPlans_title__WBLBM","badge":"ESIMSelectPlans_badge__ZmLYB","badgeActive":"ESIMSelectPlans_badgeActive__QQLNu"};